<mat-toolbar>
  <span class="fill-remaining-space">
    <mat-icon>credit_card</mat-icon>
    Card Info
  </span>
  <button class="btn-dialog-close" mat-stroked-button (click)="onClose()">
    <mat-icon>clear</mat-icon>
  </button>
</mat-toolbar>

<mat-dialog-content>
  <div style="height: fit-content !important; margin-top: 0.7rem;">
    <ng-container>
      <form [formGroup]="cardForm">
        <div class="row">
          <div class="col-12">
            <mat-slide-toggle style=" flex: 1; align-self: center;" [checked]="samePerson"
              (change)="getOwner($event.checked)">Same Person?
            </mat-slide-toggle>
          </div>
          <div class="col">
            <mat-form-field appearance="legacy">
              <mat-label>Card holder name*</mat-label>
              <input matInput type="text" formControlName="c_name" autocomplete="off">
              <mat-icon matSuffix>account_circle</mat-icon>
              <mat-error>This field is mandatory</mat-error>
            </mat-form-field>
          </div>
          <div class="col">
            <mat-form-field appearance="legacy">
              <mat-label>Card Type*</mat-label>
              <mat-select formControlName="c_type" (selectionChange)="changeInputMax($event.value)">
                <mat-option *ngFor="let cards of cardConf" value="{{cards.desc}}">{{cards.desc}}</mat-option>
              </mat-select>
              <mat-icon matSuffix>branding_watermark</mat-icon>
              <mat-error *ngIf="cardForm.controls['c_type'].errors?.required">This field is mandatory
              </mat-error>
            </mat-form-field>
          </div>
        </div> <!-- c_name, c_type-->
        <h4 style="margin: 0; padding: 0;">Card Numbers
          <mat-icon style="vertical-align: bottom">credit_card</mat-icon>
        </h4>
        <div class="row card-numbers">
          <div class="col-3 col-md-3 col-lg">
            <mat-form-field appearance="legacy">
              <input matInput formControlName="c_cn1" id="c_cn1" type="password" inputmode="numeric"
                [maxLength]="(cardConfig && cardConfig.l1) ? cardConfig.l1 : 4"
                (keyup)="keytab($event, (cardConfig && cardConfig?.l1) ? cardConfig.l1 : 4)" autocomplete="off">

              <mat-icon matSuffix>card</mat-icon>
              <mat-error *ngIf="cardForm.controls['c_cn1'].errors?.required">This
                field is required.
              </mat-error>
              <mat-error *ngIf="cardForm.controls['c_cn1'].errors?.pattern">Only
                <strong>numbers</strong> are allowed
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-3 col-md-3 col-lg">
            <mat-form-field appearance="legacy">
              <mat-label></mat-label>
              <input matInput formControlName="c_cn2" id="c_cn2" type="password" inputmode="numeric" autocomplete="off"
                [maxLength]="(cardConfig && cardConfig.l2) ? cardConfig.l2 : 4"
                (keyup)="keytab($event, cardConfig?.l2)">
              <mat-icon matSuffix>card</mat-icon>
              <mat-error *ngIf="cardForm.controls['c_cn2'].errors?.required">This
                field is required.
              </mat-error>
              <mat-error *ngIf="cardForm.controls['c_cn2'].errors?.pattern">Only
                <strong>numbers</strong> are allowed.
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-3 col-md-3 col-lg">
            <mat-form-field appearance="legacy">
              <mat-label></mat-label>
              <input matInput formControlName="c_cn3" id="c_cn3" type="password" inputmode="numeric" autocomplete="off"
                [maxLength]="(cardConfig && cardConfig.l3) ? cardConfig.l3 : 4"
                (keyup)="keytab($event, cardConfig?.l3)">
              <mat-icon matSuffix>card</mat-icon>
              <mat-error *ngIf="cardForm.controls['c_cn3'].errors?.required">This
                field is required.
              </mat-error>
              <mat-error *ngIf="cardForm.controls['c_cn3'].errors?.pattern">Only
                <strong>numbers</strong> are allowed.
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-3 col-md-3 col-lg">
            <mat-form-field appearance="legacy">
              <mat-label></mat-label>
              <input matInput formControlName="c_cn4" id="c_cn4" inputmode="numeric" autocomplete="off"
                [maxLength]="(cardConfig && cardConfig.l4) ? cardConfig.l4 : 4"
                (keyup)="keytab($event, cardConfig?.l4)">
              <mat-icon matSuffix>card</mat-icon>
              <mat-error *ngIf="cardForm.controls['c_cn4'].errors?.required">This
                field is required.
              </mat-error>
              <mat-error *ngIf="cardForm.controls['c_cn4'].errors?.pattern">Only
                <strong>numbers</strong> are allowed.
              </mat-error>
            </mat-form-field>
          </div>
        </div> <!-- c_cn1, c_cn2, c_cn3, c_cn4 -->
        <div class="row">
          <div class="col">
            <mat-form-field appearance="legacy">
              <mat-label>Expiration month*</mat-label>
              <mat-select formControlName="c_month">
                <mat-option *ngFor="let month of months" value="{{month.digit}}">{{month.month}}</mat-option>
              </mat-select>
              <mat-icon matSuffix>date_range</mat-icon>
              <mat-error *ngIf="cardForm.controls['c_month'].errors?.required">This
                field is required.
              </mat-error>
              <mat-error *ngIf="cardForm.controls['c_month'].errors?.pattern">Only
                <strong>numbers</strong> are allowed.
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col">
            <mat-form-field appearance="legacy">
              <mat-label>Expiration Year*</mat-label>
              <mat-select formControlName="c_year">
                <mat-option *ngFor="let year of validYears" value="{{year}}">{{year}}</mat-option>
              </mat-select>
              <mat-icon matSuffix>date_range</mat-icon>
              <mat-error *ngIf="cardForm.controls['c_year'].errors?.required">This
                field is required.
              </mat-error>
              <mat-error *ngIf="cardForm.controls['c_year'].errors?.pattern">Only
                <strong>numbers</strong> are allowed.
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col">
            <mat-form-field appearance="legacy">
              <mat-label>Verifiation code*</mat-label>
              <input matInput formControlName="c_code" type="password" inputmode="numeric" autocomplete="off"
                [maxLength]="(cardConfig && cardConfig.lv) ? cardConfig.lv : 4">

              <mat-icon matSuffix>call_to_action</mat-icon>
              <mat-error *ngIf="cardForm.controls['c_code'].errors?.required">This
                field is required.
              </mat-error>
              <mat-error *ngIf="cardForm.controls['c_code'].errors?.pattern">Only
                <strong>numbers</strong> are allowed.
              </mat-error>

            </mat-form-field>
          </div>
        </div> <!-- c_month, c_year, c_code-->
      </form> <!-- cardForm-->


        <hr>

<!--        <mat-accordion>-->
<!--          <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false" #compInfo>-->
<!--            <mat-expansion-panel-header>-->
<!--              <mat-panel-title>-->
<!--                Complement Information (Optional)-->
<!--              </mat-panel-title>-->
<!--            </mat-expansion-panel-header>-->
<!--            <form [formGroup]="cardForm" *ngIf="showCardComplementForm === true">-->
<!--              <div class="row">-->
<!--                <div class="col-12">-->
<!--&lt;!&ndash;                  <h4>Complement Information (Optional)</h4>&ndash;&gt;-->
<!--                </div>-->
<!--                <div class="col-12">-->
<!--                  <mat-form-field appearance="legacy">-->
<!--                    <mat-label>Card Address</mat-label>-->
<!--                    <textarea matInput cols="30" rows="3" formControlName="c_address"></textarea>-->
<!--                    <mat-error *ngIf="cardForm.controls['c_address'].errors?.required">This field is mandatory-->
<!--                    </mat-error>-->
<!--                  </mat-form-field>-->
<!--                </div> &lt;!&ndash; c_address &ndash;&gt;-->

<!--                <div class="col-12 col-md">-->
<!--                  <mat-form-field appearance="legacy">-->
<!--                    <mat-label>Card Country</mat-label>-->
<!--                    <mat-select formControlName="c_country" (selectionChange)="getStates($event.value)">-->
<!--                      <mat-option value="">Select...</mat-option>-->
<!--                      <mat-option *ngFor="let country of countries; let i = index" value="{{country.name}}"-->
<!--                                  [ngClass]="{borderBottom: i === 2}">-->
<!--                        {{country.name}}</mat-option>-->

<!--                    </mat-select>-->
<!--                    <mat-error *ngIf="cardForm.controls['c_country'].errors?.required">This field is mandatory-->
<!--                    </mat-error>-->
<!--                    <mat-icon matSuffix>location_on</mat-icon>-->
<!--                  </mat-form-field>-->
<!--                </div> &lt;!&ndash; c_country &ndash;&gt;-->

<!--                <div class="col-12 col-md">-->
<!--                  <mat-form-field appearance="legacy">-->
<!--                    <mat-label>Card State</mat-label>-->
<!--                    <mat-select formControlName="c_state" (selectionChange)="getCities($event.value)">-->
<!--                      <mat-option value="">Select...</mat-option>-->
<!--                      <mat-option *ngFor="let state of states" value="{{state.name}}">{{state.name}}</mat-option>-->
<!--                    </mat-select>-->
<!--                    <mat-icon matSuffix>location_on</mat-icon>-->
<!--                    <mat-error *ngIf="cardForm.controls['c_state'].errors?.required">This field is mandatory-->
<!--                    </mat-error>-->
<!--                  </mat-form-field>-->
<!--                </div> &lt;!&ndash; c_state &ndash;&gt;-->

<!--                <div class="col-12 col-md">-->
<!--                  <mat-form-field appearance="legacy">-->
<!--                    <mat-label>Card City</mat-label>-->
<!--                    <mat-select formControlName="c_city" (closed)="onPanelClose()"-->
<!--                                (selectionChange)="enabledOtherCity($event.value)">-->

<!--                      <div class="search">-->
<!--                        <mat-form-field class="full-width-field" style="text-align: center;">-->
<!--                          <input matInput [formControl]="filterControl" type="text" name="filter-options"-->
<!--                                 id="filter-options" placeholder=" Search" (keyup)="filtrar($event.target.value)"-->
<!--                                 autofocus>-->
<!--                        </mat-form-field>-->
<!--                      </div>-->

<!--                      <mat-option value="">Select...</mat-option>-->
<!--                      <mat-option *ngFor="let city of c_FilterCities" value="{{city.name}}">{{city.name}}-->
<!--                      </mat-option>-->
<!--                    </mat-select>-->
<!--                    <mat-icon matSuffix>location_on</mat-icon>-->
<!--                    <mat-error *ngIf="cardForm.controls['c_city'].errors?.required">This field is mandatory-->
<!--                    </mat-error>-->
<!--                  </mat-form-field>-->
<!--                </div> &lt;!&ndash; c_city &ndash;&gt;-->

<!--                <div class="col-12 col-md">-->
<!--                  <mat-form-field appearance="legacy">-->
<!--                    <mat-label>Card Zip</mat-label>-->
<!--                    <input matInput type="text" formControlName="c_zip">-->
<!--                    <mat-error *ngIf="cardForm.controls['c_zip'].errors?.required">This field is mandatory-->
<!--                    </mat-error>-->
<!--                  </mat-form-field>-->
<!--                </div> &lt;!&ndash; c_zip &ndash;&gt;-->

<!--              </div> &lt;!&ndash; complement information card &ndash;&gt;-->
<!--            </form>-->
<!--          </mat-expansion-panel>-->
<!--        </mat-accordion>-->

      <br>
      <br>


    </ng-container> <!-- card form and payment form-->
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close>Cancel</button>
  <button mat-raised-button (click)="submitCardData()" color="primary">{{saveBtnText}}</button>
</mat-dialog-actions>
